(() => {
 const key='gcs-vanity-browse';
 const hub=document.querySelector('[data-gcs-vanity-hub]');
 const read=()=>{try{return JSON.parse(sessionStorage.getItem(key)||'null')}catch{return null}};
 if(hub){
   const save=()=>{try{sessionStorage.setItem(key,JSON.stringify({url:location.pathname+location.search,y:scrollY}))}catch{}};
   hub.addEventListener('click',e=>{if(e.target.closest('a[href*="/products/"]'))save()});
   addEventListener('pagehide',save);
   const state=read();
   if(state&&state.url===location.pathname+location.search){
     addEventListener('pageshow',e=>{if(!e.persisted)requestAnimationFrame(()=>scrollTo(0,state.y||0))},{once:true});
   }
 }
 document.querySelectorAll('[data-gcs-vanity-return]').forEach(a=>{
   const state=read();
   if(state&&['/pages/our-products?view=vanities','/pages/custom-vanities'].includes(state.url))a.href=state.url;
 });
})();